import platformRepository, { Platform } from "@/repositories/platform.repository";
import {defineStore} from "pinia";
import {ref} from "vue";

declare const _platformId: number;
declare const _isGlobalPlatform: boolean;

export const usePlatformStore = defineStore("platform", () => {
    const platform = ref<Platform>();
    const platformId = _platformId;
    
    const isGlobalPlatform = _isGlobalPlatform;
    const isGolfPlatform = platformId === 6 || platformId === 7;
    
    const ensurePlatform = async () => {
        if (!platform.value?.PlatformId) {
            await platformRepository.getPlatformData(platformId).then(data => {
                platform.value = data;
            });
        }
    }
    
    return {
        platform,
        platformId,
        isGlobalPlatform,
        isGolfPlatform,
        ensurePlatform,
    }
})